import React, { useState } from 'react'
import { connect } from 'react-redux'
import I18n, { useI18nFunction } from '../I18n'
import styled, { keyframes } from 'styled-components'
import Button from '../Button'
import { Link } from 'react-router-dom'
import checkmarkIcon from '../../icons/checkmark_circled_filled.svg'
import attentionIcon from '../../icons/circled_alert_icon.svg'
import { prettyDate } from '../../dateUtils'
import ConfirmProfileButton from '../ConfirmProfileButton'
import EventList from '../EventList'
import {
  isReminderFetching,
  getUser,
  getCurrentUser,
} from '../../redux/selectors'

const ProfileStatusAndActionBar = ({
  isCurrentUsersProfile,
  userId,
  confirmedFormOn,
  hasValidConfirmationStatus,
  lastLoggedIn,
  isReminderFetching,
  isAdmin,
}) => {
  const I18nFunction = useI18nFunction();
  const [isHistoryOpen, setIsHistoryOpen] = useState(false)

  return (
    <Wrapper>
      <Content>
        <LastUpdated>
          <img
            src={hasValidConfirmationStatus ? checkmarkIcon : attentionIcon}
            title={hasValidConfirmationStatus
              ? ''
              : `${I18nFunction({ id: 'connection_form.tabs.Confirm_all_sections_of_profile_to_enable_completion' }) || ''}`
            }
          />
          <div>
            <LastUpdatedAttr>
              {I18nFunction({ id: 'Last_confirmed_on' }) + ': '}
              <Bold>
                {confirmedFormOn ? prettyDate(confirmedFormOn) : I18nFunction({ id: 'Never' })}
              </Bold>
            </LastUpdatedAttr>
            <LastUpdatedAttr>
              {I18nFunction({ id: 'Last_logged_in' }) + ': '}
              <Bold>
                {lastLoggedIn ? prettyDate(lastLoggedIn) : I18nFunction({ id: 'Never' })}
              </Bold>
            </LastUpdatedAttr>
          </div>
          {isCurrentUsersProfile ? (
            <ConfirmProfileButton
              userId={userId}
              confirmedFormOn={confirmedFormOn}
            />
          ) : (
            <Button
              pending={isReminderFetching ? 1 : 0}
              as={Link}
              to={`/reminder/confirm?users=${userId}`}
            >
              <I18n id="Send_reminder" />
            </Button>
          )}
        </LastUpdated>
        <ActionButtonWrapper>
          {(isCurrentUsersProfile || isAdmin) && (
              <Button
                onClick={() =>
                  (window.location.href = `${window.location.origin}/api/users/${userId}/generate_user_pdf`)
                }
              >
                <I18n id="Export_pdf" />
              </Button>
            )}
          <Button
            onClick={() => {
              setIsHistoryOpen((is) => !is)
            }}
          >
            {isHistoryOpen ? (
              <I18n id="Hide_profile_history" />
            ) : (
              <I18n id="Show_profile_history" />
            )}
          </Button>
        </ActionButtonWrapper>
      </Content>
      {isHistoryOpen && (
        <HistoryWrapper>
          <History>
            <HistoryTitle>
              <I18n id="Profile_history" />
            </HistoryTitle>
            <EventList userId={userId} />
          </History>
        </HistoryWrapper>
      )}
    </Wrapper>
  )
}

const Content = styled.div`
  background-color: ${({ theme: { secondaryBackground } }) =>
    secondaryBackground};
  max-width: ${({ theme: { maxWidth } }) => maxWidth};
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding-bottom: 1em;
`
const ActionButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  & > :not(:last-child) {
    margin-right: 0.5em;
  }
  & > :last-child {
    min-width: 200px;
  }
`

const Wrapper = styled.div`
  background-color: ${({ theme: { secondaryBackground } }) =>
    secondaryBackground};
`

const LastUpdated = styled.div`
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding: 0.7em 1em;
  background-color: ${({ theme: { primaryBackground } }) => primaryBackground};
  max-width: 45%;

  & > :not(:last-child) {
    margin-right: 1em;
  }
`

const LastUpdatedAttr = styled.div`
  display: flex;
  justify-content: right;
`

const Bold = styled.div`
  font-weight: bold;
`

const HistoryTitle = styled.h2`
  margin: 0;
`

const float = keyframes`
  from {
    transform: translateX(700px);
  }
  to {
    transform: translateX(0px);
  }
`

const HistoryWrapper = styled.div`
  position: absolute;
  top: 400px;
  right: 100px;
  width: 600px;
  background-color: ${({ theme: { primaryBackground } }) => primaryBackground};
  z-index: 1;
  animation: ${float} 200ms alternate ease-in-out;
  border-radius: 5px;
  box-shadow: rgb(219 219 219) 0px 2px 8px;
`

const History = styled.div`
  overflow: hidden;
  padding: 2em 2.25em;
`

const mapStateToProps = (state, props) => {
  const user = getUser(state, props.userId) || {}
  const currentUser = getCurrentUser(state)
  const isAdmin = currentUser.admin
  return {
    isCurrentUsersProfile: currentUser.id == props.userId,
    confirmedFormOn: user.confirmedFormOn,
    hasValidConfirmationStatus: user.hasValidConfirmationStatus,
    lastLoggedIn: user.lastLoggedIn,
    isReminderFetching: isReminderFetching(state),
    isAdmin: isAdmin,
  }
}

export default connect(mapStateToProps)(ProfileStatusAndActionBar)
